// Shared vocabulary + chip palettes for the Success Requests tracker.
// Keep these in sync with the backend enums in Nexus.Microservice.Integrations/main.py.

export const REQUEST_STATUSES = ['Open', 'In Progress', 'Blocked', 'Completed', 'Cancelled'];
export const REQUEST_PRIORITIES = ['Low', 'Medium', 'High', 'Urgent'];
export const REQUEST_TYPES = ['Feature', 'Bug', 'Data', 'Dashboard', 'Config', 'Access', 'Other'];

// Ordering used by the DataGrid status sort comparator (workflow order).
export const STATUS_ORDER = { Open: 0, 'In Progress': 1, Blocked: 2, Completed: 3, Cancelled: 4 };
export const PRIORITY_ORDER = { Low: 0, Medium: 1, High: 2, Urgent: 3 };

export const STATUS_CHIP_COLORS = {
    light: {
        Open:          { bg: '#e3f0ff', text: '#004df2' },
        'In Progress': { bg: '#fff3e0', text: '#e65100' },
        Blocked:       { bg: '#fce4ec', text: '#c62828' },
        Completed:     { bg: '#e8f5e9', text: '#2e7d32' },
        Cancelled:     { bg: '#eceff1', text: '#546e7a' },
    },
    dark: {
        Open:          { bg: '#1a2a4a', text: '#7eb4ff' },
        'In Progress': { bg: '#2a1a00', text: '#ffb74d' },
        Blocked:       { bg: '#2a0f14', text: '#f87171' },
        Completed:     { bg: '#0a2010', text: '#66bb6a' },
        Cancelled:     { bg: '#1c2226', text: '#90a4ae' },
    },
};

export const PRIORITY_CHIP_COLORS = {
    light: {
        Low:    { bg: '#eceff1', text: '#546e7a' },
        Medium: { bg: '#e3f0ff', text: '#004df2' },
        High:   { bg: '#fff3e0', text: '#e65100' },
        Urgent: { bg: '#fce4ec', text: '#c62828' },
    },
    dark: {
        Low:    { bg: '#1c2226', text: '#90a4ae' },
        Medium: { bg: '#1a2a4a', text: '#7eb4ff' },
        High:   { bg: '#2a1a00', text: '#ffb74d' },
        Urgent: { bg: '#2a0f14', text: '#f87171' },
    },
};
